import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { getStoredUser } from "./hooks/useAuth";
import { migrateLegacyStorage } from "./lib/storage";


function App() {
  useEffect(() => {
    const u = getStoredUser();
    if (u && !localStorage.getItem('portal_mirror')) {
      // Активная сессия, созданная до введения зеркал.
      migrateLegacyStorage(u.username);
      localStorage.setItem(
        'portal_mirror',
        JSON.stringify({ id: 'default', label: 'Основной', vacancies: ['hr-manager', 'chat-operator'] }),
      );
    }
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
